<template>
    <b-modal
        :ref="modalId"
        lazy
        title-tag="h2"
        title="Warning"
        footer-class="d-flex"
        @hidden="cancel"
    >
        <p>
            Removing the next due date for this item will disable any actions to
            create reminders for this item. Do you wish to continue?
        </p>
        <div slot="modal-footer" class="w-100">
            <modal-footer
                okTitle="Save"
                :isLoading="isLoading"
                @ok-action="proceed"
                @cancel-action="cancel"
            />
        </div>
    </b-modal>
</template>

<script type="text/javascript">
/**
 * @name ModalConfirmUpdateUses
 * @description Confirmation to update uses base price when make a change to item base price
 */

export default {
    components: {
        ModalFooter: () => import("@/components/elements/modal-footer")
    },
    props: {},
    data() {
        return {
            isLoading: false,
            modalId: "modalConfirmUses"
        };
    },
    methods: {
        open() {
            this.$refs[this.modalId].show();
        },
        /**
         * @method proceed
         * @description Proceed the item update with make a change to uses base price
         */
        proceed() {
            this.$emit("proceed", true);
            this.$refs[this.modalId].hide();
        },
        /**
         * @method cancel
         * @description Cancelling the item update
         */
        cancel() {
            this.$refs[this.modalId].hide();
            this.$emit("cancel", false);
        }
    }
};
</script>
